import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { VehicleModel, buildPopularStylesPath } from 'client/data/models/vehicle-v2';
import { isPreProd, isUsed } from 'site-modules/shared/utils/publication-states';
import { flow, get } from 'lodash-es';
import { connect } from 'react-redux';
import { DEALERLESS_OEM } from 'site-modules/shared/constants/oem';
import { buildTrimSummariesPath } from 'client/data/models/inventory-core-configurations';
import { getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { VisitorModel } from 'client/data/models/visitor';
import { getUnifiedLeadFormDealerCountV2Path, UnifiedLeadFormModel } from 'client/data/models/unified-lead-form';
import { LEAD_FORM_CONFIGS } from 'site-modules/shared/constants/lead-form/lead-form-configs';
import { buildPreProdContentPath, EditorialReviewModel } from 'client/data/models/editorial-review';
import { withTrimSummary } from 'site-modules/personalized-search/components/with-trim-summary/with-trim-summary';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';
import { PageModel } from 'client/data/models/page';

const mapStateToProps = state => ({
  pageName: get(state, 'pageContext.legacy.pageName') || get(state, 'pageContext.page.name'),
});

export const overviewCtaDataProvider = flow(
  connect(mapStateToProps),
  component =>
    connectToModel(component, {
      visitorLocation: bindToPath('location', VisitorModel),
      location: bindToPath('location', PageModel, null, false),
      mostPopularStyleId: bindToPath(
        ({ vehicle }) =>
          vehicle &&
          !isUsed(vehicle.pubStates) &&
          isPreProd(vehicle.pubStates) &&
          buildPopularStylesPath(getParamsFromVehicle(vehicle)),
        VehicleModel,
        styles => get(styles, '[0].id'),
        false
      ),
      leadFormDealerCount: bindToPath(
        ({ vehicle }) =>
          vehicle &&
          !isUsed(vehicle.pubStates) &&
          isPreProd(vehicle.pubStates) &&
          getUnifiedLeadFormDealerCountV2Path({
            makeSlug: vehicle.make.slug,
            modelSlug: vehicle.model.slug,
            strategy: LEAD_FORM_CONFIGS.QUICK_QUOTES_ROI.strategy,
          }),
        UnifiedLeadFormModel,
        null,
        false
      ),
      firstContent: bindToPath(
        ({ vehicle }) =>
          vehicle &&
          !isUsed(vehicle.pubStates) &&
          isPreProd(vehicle.pubStates) &&
          buildPreProdContentPath(getParamsFromVehicle(vehicle)),
        EditorialReviewModel,
        null,
        false
      ),
      selectedFilters: bindToPath(PersonalizedSearchPaths.getSelectedFilters(), PersonalizedSearchModel, null, false),
    }),
  withTrimSummary({
    path: ({ vehicle }) =>
      vehicle &&
      !isUsed(vehicle.pubStates) &&
      !isPreProd(vehicle.pubStates) &&
      !DEALERLESS_OEM.includes(vehicle.make.slug) &&
      buildTrimSummariesPath(getParamsFromVehicle(vehicle)),
  })
);
